import React from "react";
import styles from "./styles.scss";
import { Skeleton } from "@common/skeleton";

function Project() {
  return <Skeleton className={styles.project} />;
}

export { Project };
